import { CommonConstants } from '../common/CommonConstants';

/** LocalizationCode values derived from CommonConstants.Database.LocalizationCode. */
export const LocalizationCodeValues = Object.values(CommonConstants.Database.LocalizationCode) as string[];

/** LocalizationCode is the union of all possible CommonConstants.Database.LocalizationCode values. */
export type LocalizationCode = (typeof LocalizationCodeValues)[number];
